export default {"src":"/_next/static/media/Content.619172b9.svg","height":431,"width":702};